'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'
import type { TrackingEmailClick } from '../services/tracking.eventTypes'
import { pushToGtmDataLayer } from '../services/tracking.gtm'

export function MailAnalytics() {
  const hasTracked = useRef(false)
  const searchParams = useSearchParams()
  const pathname = usePathname()

  useEffect(() => {
    if (hasTracked.current) return

    const utmSource = searchParams.get('utm_source')
    const utmMedium = searchParams.get('utm_medium')

    if (utmSource !== 'trigger' || utmMedium !== 'email') {
      return
    }

    const utmCampaign = searchParams.get('utm_campaign')

    if (!utmCampaign) {
      return
    }

    hasTracked.current = true

    const eventData: TrackingEmailClick = {
      event: 'email_click',
      utm_source: utmSource,
      utm_medium: utmMedium,
      utm_campaign: utmCampaign,
      utm_content: searchParams.get('utm_content') ?? undefined,
      page_path: pathname,
    }

    pushToGtmDataLayer(eventData)

    const url = new URL(window.location.href)
    const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
    utmParams.forEach((param) => url.searchParams.delete(param))

    window.history.replaceState(null, '', url.toString())
  }, [searchParams, pathname])

  return null
}
